<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">
      <v-row>
        <v-col cols="8">Pesanan Dropshipper</v-col>
        <v-col cols="4 text-right d-none">
          <v-btn
            outlined
            class="text-subtitle-2 text-capitalize"
          >
          <v-icon center class="mr-2">mdi-download</v-icon> Unduh Laporan Penjualan
          </v-btn>
        </v-col>
      </v-row>
    </h2>

    <v-card outlined class="px-3 py-3" v-show="!loading">
      <v-tabs grow show-arrows v-model="intabs">
        <v-tab class="text-caption font-weight-bold">
          Semua
          <v-chip
              small
              class="mx-2"
              color="green"
              text-color="white"
            >
              {{ totalData }}
            </v-chip>
        </v-tab>
        <template v-for="(status, idx) in allowedStatus">
          <v-tab class="text-caption font-weight-bold" :key="idx">
            {{ (status == 'Menunggu Approval Pembayaran') ? 'Approval Pembayaran' : (status == 'Menunggu Pembayaran') ? 'Pesanan Baru' : status }}
            <v-chip
              small
              class="mx-2"
              color="green"
              text-color="white"
            >
              {{ showStatusCount(status) }}
            </v-chip>
          </v-tab>
        </template>

        <v-tab-item>
          <pesananData :allowedStatus="allowedStatus" v-if="intabs === 0"></pesananData>
        </v-tab-item>

        <!-- <template v-for="(status, idlist) in filterStatus(statusTransaksi)"> -->
        <template v-for="(status, idlist) in allowedStatus">
          <v-tab-item :key="idlist">
            <pesananData :allowedStatus="[status]" v-if="intabs === (idlist + 1)"></pesananData>
          </v-tab-item>
      </template>

      </v-tabs>
    </v-card>

    <hwiloader :messages="'Sedang memuat data pesanan dropshipper...'" v-if="loading"></hwiloader>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import pesananData from './components/pesananData'

export default {
  components: {
		pesananData,
  },
  data() {
    return {
      intabs: 0,
      status: [],
      allowedStatus: ['Menunggu Diproses', 'Diproses', 'Dibatalkan', 'Dikirim', 'Diterima', 'Selesai'],
      dataStats: [],
      totalData: 0,
      dialogWaitPaymentList: false,
      unpaid: 0,
      loading: false
    }
  },
  computed: {
    ...mapState('transaksiDropship', ['statusTransaksi', 'transaksiDropshipper']),
  },
  methods: {
    ...mapActions('transaksiDropship', ['getDropshipperTransaction', 'getDropshipStatus']),

    filterStatus(data) {
      if (data) {
        let showStatus = data.filter(d => this.allowedStatus.includes(d))
        return showStatus
      }
    },

    getCountStatus(status) {
      if (this.transaksiDropshipper) {
        const data = [...this.transaksiDropshipper.lists]
        const coundData = data.filter(item => item.trx_dropship_status == status)
        return coundData.length
      }
    },

    getCountTransaksiData() {
      let counts = []
      let these = this
      if (this.transaksiDropshipper) {
        this.allowedStatus.map(item => {
          counts.push({
            status: item,
            count: these.getCountStatus(item)
          })
        })
      }

      this.dataStats = counts
      this.totalData = this.dataStats.reduce((accumulator, current) => accumulator + current.count, 0)
    },

    showStatusCount(status) {
      const statusData = this.dataStats.find(x => x.status == status)
      if (statusData) return statusData.count
    }
  },
  async created() {
    this.$store.dispatch('setPageTitle', `Pesanan Saya`);
    let params = {
      page: 0,
      sort: 'trx_datetime',
      dir: 'DESC'
    }

    this.loading = await true

    await this.getDropshipStatus()
    await this.getDropshipperTransaction(params)
    this.getCountTransaksiData()
    // this.getUnpaid()

    let vparams = this.$route.query.v
    let vindex = 0

    if (vparams !== undefined || vparams !== '') {
      let tabstatus = (vparams == 'approval-pembayaran') ? 'menunggu-approval-pembayaran' : (vparams == 'pesanan-baru') ? 'menunggu-pembayaran' : vparams
        this.allowedStatus.map((status, idx) => {
        let tabname = status.toLowerCase().replaceAll(' ', '-')
        if (tabstatus == tabname) vindex = idx + 1
        // console.log(tabstatus + ' === ' + tabname + ' == ' + vindex)
      })
      
      this.intabs = vindex
    }

    if (this.intabs > 0) {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 600);
    } else {
      this.loading = false
    }
  },
}
</script>